export { default as register } from './register'
